import script from "./FeedbackFormUsefulSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackFormUsefulSection.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackFormUsefulSection.vue?vue&type=style&index=0&id=aa6b3bc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa6b3bc4"]])

export default __exports__